<div class="item-container">
    <div class="item-header">
        <h5 class="text-center">Repeat</h5>
        <div class="edit-icons" (click)="onCancel()">
            <i class="material-icons">close</i>
        </div>
    </div>
    <div class="item-content d-flex flex-column justify-content-center mt-4">
        <form action="" [formGroup]="addForm">
            <label for="">Repeat</label>
            <mat-select class="form-control" placeholder="Select Frequency" formControlName="frequency" (selectionChange)="onSelectFrequency($event)">
                <mat-option value="2">Daily</mat-option>
                <mat-option value="1">Weekly</mat-option>
                <mat-option value="0">Monthly</mat-option>
            </mat-select>
            <mat-error *ngIf="isControlHasError('frequency','required')"> {{"This is required"|translate}}</mat-error>
            <div class="mt-4 d-flex align-items-center">
                <div>Every </div>
                <div class="ms-3 me-3">
                    <mat-select class="form-control" style="width: 100px;" formControlName="every" placeholder="Select">
                        <mat-option [value]="item" *ngFor="let item of repeatEveryArr">{{item}}</mat-option>
                    </mat-select>
                    <div>
                        <mat-error *ngIf="isControlHasError('every','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
                <div *ngIf="frequencyType=='weekly'">Week(s)</div>
                <div *ngIf="frequencyType=='daily'">Days</div>
                <div *ngIf="frequencyType=='monthly'">Months</div>
            </div>
            <div class="mt-4 d-flex align-items-center" *ngIf="frequencyType=='monthly'">
                <div>Repeats On </div>
                <div class="ms-3 me-3">
                    <mat-select class="form-control" style="width: 180px;" formControlName="monthFrequency" placeholder="Select" 
                    (selectionChange)="onSelectRepeatMonth($event)">
                        <mat-option *ngFor="let item of repeatArr" [value]="item.value">{{item.name}}</mat-option>
                    </mat-select>
                    <div>
                        <mat-error *ngIf="isControlHasError('monthFrequency','required')"> {{"This is required"|translate}}</mat-error>
                    </div>
                </div>
            </div>
            <div class="mt-4 d-flex align-items-center" *ngIf="frequencyType=='weekly'">
                <div class="me-2">On</div>
                <div class="w-item" *ngFor="let item of weekdaysArr" (click)="onSelectDay(item)" [ngClass]="item.isSelected ? 'week-selected' : '' ">
                    {{item.val}}
                </div>
            </div>
            <div class="mt-4">
                <div class="d-flex align-items-center flex-wrap gap-3">
                    <div class="me-2">Ends</div>
                    <div>
                        <mat-select class="form-control" style="width:120px" formControlName="endFrequency"
                            (selectionChange)="onEndType($event)" placeholder="Select">
                            <mat-option value="0">On</mat-option>
                            <mat-option value="1">After</mat-option>
                        </mat-select>
                        <div>
                            <mat-error *ngIf="isControlHasError('endFrequency','required')"> {{"This is required"|translate}}</mat-error>
                        </div>
                    </div>
                    <div class="d-flex align-items-center ">
                        <div>
                            <div class="in-box ms-3" *ngIf="endType=='on'">
                                <input class="form-control" [matDatepicker]="sDate" placeholder="Select Date"  formControlName="endDate" />
                                <mat-datepicker-toggle matIconSuffix [for]="sDate"></mat-datepicker-toggle>
                                <mat-datepicker #sDate></mat-datepicker>
                            </div>
                            <mat-error *ngIf="isControlHasError('endDate','required')"> {{"This is required"|translate}}</mat-error>
                        </div>
                        <div>
                            <div class="me-2  d-flex align-items-center" *ngIf="endType=='after'">
                                <input type="number" class="form-control me-2" formControlName="occurrences">Occurrences
                            </div>
                            <mat-error *ngIf="isControlHasError('occurrences','required')"> {{"This is required"|translate}}</mat-error>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="col-md-6 m-auto">
            <button mat-raised-button color="primary" class="auth-form-btn mt-3 mt-lg-4" type="submit" (click)="onSubmit()">
                {{ "BUTTON.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
<app-loading-spinner></app-loading-spinner>